import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
/**
 * The action bar pinned to the bottom of the widget card.
 *
 * It anchors to the route wrapper, which is the only positioned ancestor and is always the full
 * height of the card, so the bar sits at the bottom of the widget rather than at the bottom of the
 * view's content. Because that ancestor lives outside the scrolling box, the bar stays put while
 * the view scrolls underneath it - which is the whole point: the next step is reachable without
 * scrolling to the end of a long form or product list.
 */
export default function BottomBar({ children }) {
    const theme = useTheme();
    return (_jsx(Box, { sx: {
            position: 'absolute',
            bottom: '0',
            borderColor: theme.palette.divider,
            borderWidth: '1px 0 1px 0',
            borderStyle: "solid",
            // The bar bleeds over the 16px the card pads its content with, so it
            // reaches the edges either side, and the button sits 32px in from those.
            // border-box is what makes that hold: with the default content-box the
            // 32px of padding is added on top of the width, and the bar ends up
            // wider than the card - which is what pushed the button off the right
            // edge in standalone mode. The two modes measure the same, so neither
            // needs a rule of its own.
            boxSizing: 'border-box',
            left: '-16px',
            width: 'calc(100% + 32px)',
            paddingX: '32px',
            backgroundColor: theme.palette.background.paper,
            zIndex: 1000
        }, children: children }));
}
